import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Paths } from "../common/constants";
import { useIsLoggedIn } from "../hooks/useIsLoggedIn";

const PublicRoute = ({ children }: any) => {
  const isLoggedIn = useIsLoggedIn();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return isLoggedIn ? <Navigate to={Paths.ORGANIZATION} /> : children;
};

export default PublicRoute;
